import Vue from 'vue'

const app = {
    state: {
        queryLoading: false,
        actionLoading: false,
        loading: {},
        notifications: [],
        requestResponse: {},
        routerInfo: {}
    },
    mutations: {
        PAGE_LOADING: (state, {value, api}) => {
            state.queryLoading = value;
            Vue.set(state.loading, api.code, value);
        },
        ACTION_LOADING: (state, {value, api}) => {
            state.actionLoading = value;
            Vue.set(state.loading, api.code, value);
        },
        HTTP_RESPONSE: (state, {responseCode, responseErrorMessage, action}) => {
            //避免消息内容一样无法更新
            state.requestResponse = {};
            state.requestResponse.responseErrorMessage = responseErrorMessage;
            state.requestResponse.responseCode = responseCode;
            state.requestResponse.action = action;
        },
        //设置通知列表
        SET_NOTIFICATION: (state, notifications) => {
            state.notifications = notifications;
        }
    },
    actions: {
        setQueryLoading(context, {value, api}) {
            context.commit("PAGE_LOADING", {value, api});
        },
        setActionLoading(context, {value, api}) {
            context.commit("ACTION_LOADING", {value, api});
        },
        setHttpResponse(context, {responseCode, responseErrorMessage, action}) {
            context.commit("HTTP_RESPONSE", {responseCode, responseErrorMessage, action});
        },
        showMessage(context, {messageText, messageType, action}) {
            if (messageText) {
                messageText = messageText.replace('\r\n', "<br/>");
            }
            context.commit("HTTP_RESPONSE", {
                responseCode: messageType,
                responseErrorMessage: messageText,
                action: action
            });
        },
        setNotifications(context, notifications) {
            context.commit("SET_NOTIFICATION", notifications);
        }
    }
}
export default app;